import { Divider, Grid } from '@zillow/constellation';

export function CenteredHR(): JSX.Element {
  return (
    <Grid display="grid" gridTemplateColumns="repeat(12, 1fr)">
      <Grid gridColumnEnd="span 2" />
      <Grid gridColumnEnd="span 8">
        <Divider marginY="xs" />
      </Grid>
      <Grid gridColumnEnd="span 2" />
    </Grid>
  );
}
